'use strict';

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
  let $updates = $results.find(selector);
  $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
  // $('.refinement.active').each(function () {
  //   $(this).removeClass('active');
  //   let activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
  //   activeDiv.addClass('active');
  //   activeDiv.find('button.title').attr('aria-expanded', 'true');
  // });

  updateDom($results, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
  let $results = $(response);
  let specialHandlers = {
    '.refinements': handleRefinements,
  };

  // Update DOM elements that do not require special handling
  ['.grid-header', '.header-bar', '.header.page-title', '.product-grid', '.show-more', '.product-count','.js-datalayer-info', '.page-size'].forEach(function (selector) {
    updateDom($results, selector);
  });

  // Object.keys(specialHandlers).forEach(function (selector) {
  //   specialHandlers[selector]($results);
  // });
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
  let showMoreUrl = $element.data('url');
  // $.spinner().start();
  $.ajax({
    url: showMoreUrl,
    method: 'GET',
    success: function (response) {
      $target.append(response);
      // $.spinner().stop();
    },
    error: function () {
      // $.spinner().stop();
    },
  });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
  let $tempDom = $('<div>').append($(response));
  let sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
  sortOptions.forEach(function (option) {
    $('option.' + option.id).val(option.url);
  });
}

function saveCategoryInLocalStorage() {
  var currentCategory = $('.js-grid').data('category-id');
  if (currentCategory) {
    window.localStorage.setItem('currentCategory',  currentCategory);
  }
}

function checkCategory() {
  var currentCategory = $('.js-grid').data('category-id');
  var localStorageCategory = window.localStorage.getItem('currentCategory');
  return currentCategory === localStorageCategory;
}

function scrollToPosition(position) {
  if (!position) {
    return;
  }
  window.localStorage.setItem('autoScroll',  'true');
  $('html, body').scrollTop(0);
  $('html, body').animate({scrollTop:position || 0}, 400, function() {
    window.localStorage.removeItem('autoScroll');
  });
}

function renderProducts(href, sortValue, position) {
  $.ajax({
    url: href,
    data: {
      page: $('.grid-footer').data('page-number'),
      selectedUrl: href,
    },
    method: 'GET',
    success: function (response) {
      parseResults(response);
      clickSort(sortValue);
      scrollToPosition(position)
      // $.spinner().stop();
      let $results = $(response);
      var dl = $results.prev('.js-datalayer-info')[0].innerHTML;
      var sz = $results.prev('.page-size')[0].innerHTML;
      var datalayer = JSON.parse(dl);
      var pageSize = JSON.parse(sz);
      var datalayerImpression = datalayer.ecommerce.impressions;

      window.dataLayer.forEach(function (event, index) {
        if (event.event === 'productImpressions') {
          window.dataLayer.splice(index, index)
        }
      });

      if(datalayerImpression.length <= pageSize){
        window.dataLayer.push(datalayer);
      } else {
        var chunk = pageSize;
        var newList;
        
        for(var i = 0; i < datalayerImpression.length; i += chunk){
          newList = datalayerImpression.slice(i, i + chunk);
          window.dataLayer.push({
            event: 'productImpressions',
              ecommerce: {
                currencyCode: datalayer.ecommerce.currencyCode,
                impressions: newList,
              }
          });
        }
      }
    },
    error: function () {
      // $.spinner().stop();
    },
  });
}

function sortProducts(href) {
  $.ajax({
    url: href,
    data: { selectedUrl: href },
    method: 'GET',
    success: function (response) {
      $('.product-grid').empty().html(response);
      // $.spinner().stop();
    },
    error: function () {
      // $.spinner().stop();
    },
  });
}

function updateURLParameter (url, param, paramVal) {
 let newAdditionalURL = '';
 let tempArray = url.split('?');
 let baseURL = tempArray[0];
 let additionalURL = tempArray[1];
 let temp = '';
 if (additionalURL) {
   tempArray = additionalURL.split('&');
   for (let i = 0; i < tempArray.length; i++) {
     if (tempArray[i].split('=')[0] != param) {
       newAdditionalURL += temp + tempArray[i];
       temp = '&';
     }
   }
 }

 let rows_txt = temp + '' + param + '=' + paramVal;
 return baseURL + '?' + newAdditionalURL + rows_txt;
}

function clickSort(sortValue) {
  if (sortValue) {
    var selectEl = $('.js-sort-select');
    var selectedOption = selectEl.find('*[data-id="' + sortValue + '"]');
    if (selectedOption && selectedOption.length) {
      selectEl.val(selectedOption.val()).change();
    }
  }
}

module.exports = {
  filter: function () {
    // Display refinements bar when Menu icon clicked
    $('.grid-header').on('click', 'button.filter-results', function () {
      $('.refinement-bar, .modal-background').show();
      $('.refinement-bar').siblings().attr('aria-hidden', true);
      $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
      $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
      $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', true);
      $('.refinement-bar .close').focus();
    });
  },

  closeRefinements: function () {
    // Refinements close button
    $('.grid-header').on('click', '.refinement-bar button.close, .modal-background', function () {
      $('.refinement-bar, .modal-background').hide();
      $('.refinement-bar').siblings().attr('aria-hidden', false);
      $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
      $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
      $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
      $('.btn.filter-results').focus();
    });
  },

  resize: function () {
    // // Close refinement bar and hide modal background if user resizes browser
    // $(window).resize(function () {
    //   $('.refinement-bar, .modal-background').hide();
    //   $('.refinement-bar').siblings().attr('aria-hidden', false);
    //   $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
    //   $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
    //   $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
    // });
  },

  sort: function () {
    // Handle sort order menu selection
    $('.grid-header').on('change', '[name=sort-order]', function (e) {
      e.preventDefault();
      
      try {
        let sortOption = $(this)[0].selectedOptions[0];
        let sortValue = $(sortOption).data('id');
        if (sortValue) {
          window.localStorage.setItem('sortValue', sortValue);
          saveCategoryInLocalStorage();
        }
      } catch(err) {
        console.error('Error saving sort value:' + err);
      }

      saveCategoryInLocalStorage();

      // $.spinner().start();
      $(this).trigger('search:sort', this.value);
      sortProducts(this.value);
    });
  },

  showMore: function () {
    // Show more products
    $('.container').on('click', '.show-more button', function (e) {
      e.stopPropagation();
      let showMoreUrl = $(this).data('url');
      e.preventDefault();

      // $.spinner().start();
      $(this).trigger('search:showMore', e);
      $.ajax({
        url: showMoreUrl,
        data: { selectedUrl: showMoreUrl },
        method: 'GET',
        success: function (response) {
          $('.grid-footer').replaceWith(response);
          updateSortOptions(response);
          // $.spinner().stop();
        },
        error: function () {
          // $.spinner().stop();
        },
      });
    });
  },

  applyFilter: function () {
    // Handle refinement value selection and reset click
    $('.grid-header').on('click', '.refinements li button, .refinements button.reset, .filter-value button, .swatch-filter button', function (e) {
      e.preventDefault();
      e.stopPropagation();
  
      window.localStorage.setItem('filterValue', $(this).data('href'));
      window.localStorage.removeItem('sortValue');
      saveCategoryInLocalStorage();

      // $.spinner().start();
      $(this).trigger('search:filter', e);
      renderProducts($(this).data('href'));
    });
  },

  showContentTab: function () {
    // Display content results from the search
    $('.container').on('click', '.content-search', function () {
      if ($('#content-search-results').html() === '') {
        getContent($(this), $('#content-search-results'));
      }
    });

    // Display the next page of content results from the search
    $('.container').on('click', '.show-more-content button', function () {
      getContent($(this), $('#content-search-results'));
      $('.show-more-content').remove();
    });
  },

  saveScrollPosition: function () {
    $(window).scroll(function() {
      let autoScroll = window.localStorage.getItem('autoScroll');
       if (!autoScroll) {
        window.localStorage.setItem('scrollPosition',  $('html, body').scrollTop());
        let filterValue = window.localStorage.getItem('filterValue');
        if (!filterValue) {
          let resetUrl = $('.js-reset').data('href');
          window.localStorage.setItem('filterValue', resetUrl);
        }
        saveCategoryInLocalStorage();
       }
    });
  },

  restoreSearchState: function () {
    $( document ).ready(function() {
      if (checkCategory()) {
        let position = window.localStorage.getItem('scrollPosition');
        let filterValue = window.localStorage.getItem('filterValue');
        let scrollSize = window.localStorage.getItem('scrollSize');
        if (filterValue && scrollSize) {
          filterValue = updateURLParameter(filterValue, 'start', 0);
          filterValue = updateURLParameter(filterValue, 'sz', scrollSize);
        }

        let sortValue = window.localStorage.getItem('sortValue');
        if (filterValue) {
          filterValue = filterValue.replace(/\/[a-z]{2}[_][A-Z]{2}\//, `/${window.locale}/`);
          renderProducts(filterValue, sortValue, position);
        } 
      } else {
        window.localStorage.removeItem('scrollPosition');
        window.localStorage.removeItem('filterValue');
        window.localStorage.removeItem('sortValue');
        window.localStorage.removeItem('currentCategory');
        window.localStorage.removeItem('scrollSize');
      }
    })
  },

  showOrHideFooterDescription: function () {
    $('.read-more-button').on('click', () => {
      const parent = $('.read-more-button').closest('.plp-description-footer');
      const textMore = $('.read-more-text');
      const textLess = $('.read-less-text');      
  
      if(parent.hasClass('read-show-more-expanded')){
          parent.removeClass('read-show-more-expanded').addClass('read-show-more');
          textMore.removeClass('d-none');
          textLess.addClass('d-none');       
          
      } else{
          parent.removeClass('read-show-more').addClass('read-show-more-expanded');
           textLess.removeClass('d-none');
          textMore.addClass('d-none');
      }
    });
  }
};
